import forge from "node-forge";
var CryptoJS = require("crypto-js");

let AES_SECRET_KEY = null;
let AES_IV = null;

const initializeEncryptionSession = async () => {
    try {
        // 1. Generate RSA keypair
        const keypair = forge.pki.rsa.generateKeyPair({ bits: 2048 });
        const privateKey = keypair.privateKey;
        const publicKeyPem = forge.pki.publicKeyToPem(keypair.publicKey);

        // 2. Send public key to server
        const response = await fetch(`${process.env.REACT_APP_API_URL}/v1/init`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ initPayload: publicKeyPem }),
        });

        const { encryptedPayload } = await response.json();

        // 3. Decrypt AES key and IV using privateKey
        const decrypted = privateKey.decrypt(forge.util.decode64(encryptedPayload), "RSA-OAEP");
        const { key, iv } = JSON.parse(decrypted); // base64 strings


        AES_SECRET_KEY = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(key));
        AES_IV = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(iv));

    } catch (e) {
        console.error("Something went worng", e)
    }
};


function useEncryption() {

    const encrypt = async (value) => {
        if (!AES_SECRET_KEY || !AES_IV) await initializeEncryptionSession()
        if (!value) return null;
        const serializedValue = JSON.stringify(value);
        var key = CryptoJS.enc.Latin1.parse(AES_SECRET_KEY);
        var iv = CryptoJS.enc.Latin1.parse(AES_IV);

        const ciphertext = CryptoJS.AES.encrypt(serializedValue, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }).toString();

        return ciphertext;
    }
    const decrypt = async (value) => {
        if (!AES_SECRET_KEY || !AES_IV) await initializeEncryptionSession()
        if (!value) return null;
        var key = CryptoJS.enc.Latin1.parse(AES_SECRET_KEY);
        var iv = CryptoJS.enc.Latin1.parse(AES_IV);

        const bytes = CryptoJS.AES.decrypt(value, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        const plaintext = bytes.toString(CryptoJS.enc.Utf8);
        const parsedPlainText = await JSON.parse(plaintext)
        return parsedPlainText;
    }

    return { encrypt, decrypt };
}

export default useEncryption;
